import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { Modal } from "@domestika-dev/prudencio/dist/molecules/Modal";
import * as LiveSetupSteps from "../../constants/liveSetupSteps";
import * as LiveSetupModalModes from "../../constants/liveSetupModalModes";
import { LiveSetupCredentialsStep } from "./LiveSetupCredentialsStep";
import { LiveSetupCreateLobbyStep } from "./LiveSetupCreateLobbyStep";

export const LiveSetupModal = ({ initialStep, mode, enableNavigation, onClose, liveChannel }) => {
  const [liveSetupStep, setLiveSetupStep] = useState(initialStep);
  const [isOpen, setOpen] = useState();

  const onCloseHandler = () => {
    setOpen(false);
    onClose();
  };

  const getCredentialsSetupStepContent = () => (
    <LiveSetupCredentialsStep
      enableNavigation={enableNavigation}
      liveChannel={{
        id: liveChannel?.id,
        streamKeyValue: liveChannel?.streamKeyValue,
        ingestEndpoint: liveChannel?.ingestEndpoint,
      }}
      onNextStep={() => {
        setLiveSetupStep(LiveSetupSteps.CREATE_LOBBY);
      }}
      onClose={onCloseHandler}
    />
  );

  const getCreateLobbyStepContent = () => (
    <LiveSetupCreateLobbyStep
      mode={mode}
      enableNavigation={enableNavigation}
      onNextStep={() => {
        setOpen(false);
        onClose({ liveSessionReadySubmit: true });
      }}
      onPreviousStep={() => {
        setLiveSetupStep(LiveSetupSteps.CREDENTIALS_SETUP);
      }}
      onClose={onCloseHandler}
    />
  );

  const stepsMap = {
    [LiveSetupSteps.CREDENTIALS_SETUP]: () => getCredentialsSetupStepContent(),
    [LiveSetupSteps.CREATE_LOBBY]: () => getCreateLobbyStepContent(),
  };

  useEffect(() => {
    setOpen(true);
  }, []);

  return (
    <Modal
      maxWidth={["95vw", "100%", "826px"]}
      width={["100%", "100%", "auto"]}
      paddingX={["16px", "40px", "80px"]}
      paddingY={["16px", "40px", "40px"]}
      heigth="auto"
      style={{ maxHeight: "95vh" }}
      isOpen={isOpen}
      id="dmstk-setup-modal"
      onModalClose={onCloseHandler}
    >
      {stepsMap[liveSetupStep]()}
    </Modal>
  );
};

LiveSetupModal.propTypes = {
  initialStep: PropTypes.oneOf([LiveSetupSteps.CREDENTIALS_SETUP, LiveSetupSteps.CREATE_LOBBY]),
  mode: PropTypes.oneOf([LiveSetupModalModes.EDITION, LiveSetupModalModes.READ_ONLY]),
  enableNavigation: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
  liveChannel: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    streamKeyValue: PropTypes.string,
    ingestEndpoint: PropTypes.string,
  }),
};

LiveSetupModal.defaultProps = {
  initialStep: LiveSetupSteps.CREDENTIALS_SETUP,
  mode: LiveSetupModalModes.READ_ONLY,
  enableNavigation: false,
  liveChannel: {},
};

export default LiveSetupModal;
